var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { isNil } from 'lodash-es';
import { resolveIconTranslationKey } from '../shared/icon/icon.metadata';
import { hideMenuProvider } from '../utilities/picker.tools';
import { translate } from '../utilities/translate';
import styles from './sds-icon-picker.lit.scss';
import './sds-inner-icon-picker/sds-inner-icon-picker.lit';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-icon-picker` is a web component designed for selecting an icon from a predefined set.
 * It allows users to easily choose an icon for various applications, such as
 * customizing user interfaces, selecting features, or tagging items.
 *
 * The component features customizable attributes, including options for error handling
 * and validation.
 *
 * ### Attributes
 * - `invalid`: A boolean indicating if the selection is invalid. Defaults to `false`.
 * - `error-message`: The error message to display if validation fails.
 * - `value`: The currently selected icon value, reflecting the selected icon or undefined.
 *
 * @tag sds-icon-picker
 */
let SdsIconPicker = (() => {
    var _SdsIconPicker_opened_accessor_storage, _SdsIconPicker_invalid_accessor_storage, _SdsIconPicker_errorMessage_accessor_storage, _SdsIconPicker_value_accessor_storage, _SdsIconPicker__contextMenu_accessor_storage, _SdsIconPicker__iconPickerInput_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-icon-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _opened_decorators;
    let _opened_initializers = [];
    let _opened_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __iconPickerInput_decorators;
    let __iconPickerInput_initializers = [];
    let __iconPickerInput_extraInitializers = [];
    var SdsIconPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsIconPicker_opened_accessor_storage.set(this, __runInitializers(this, _opened_initializers, false));
            _SdsIconPicker_invalid_accessor_storage.set(this, (__runInitializers(this, _opened_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsIconPicker_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsIconPicker_value_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _value_initializers, void 0)));
            _SdsIconPicker__contextMenu_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsIconPicker__iconPickerInput_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __iconPickerInput_initializers, void 0)));
            this._innerIconPicker = __runInitializers(this, __iconPickerInput_extraInitializers);
            this.toggleContextMenu = () => {
                if (this.opened) {
                    this.hideContextMenu();
                }
                else {
                    this.showContextMenu();
                }
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!this.opened) {
                    (_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.show(this._iconPickerInput);
                    (_b = this._innerIconPicker) === null || _b === void 0 ? void 0 : _b.scrollToSelected();
                    this.opened = true;
                }
            };
            this.hideContextMenu = () => {
                var _a;
                if (this.opened) {
                    (_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.hide();
                    this.opened = false;
                    setTimeout(() => {
                        var _a;
                        if (!this.opened) {
                            (_a = this._innerIconPicker) === null || _a === void 0 ? void 0 : _a.resetSearch();
                        }
                    }, 10);
                }
            };
            this.hideMenu = (event) => {
                var _a, _b;
                hideMenuProvider(this)(event);
                this.opened = (_b = (_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) !== null && _b !== void 0 ? _b : false;
                setTimeout(() => {
                    var _a;
                    if (!this.opened) {
                        (_a = this._innerIconPicker) === null || _a === void 0 ? void 0 : _a.resetSearch();
                    }
                }, 10);
            };
            // region events
            this.handleInnerIconPickerChange = (event) => {
                this.value = event.detail.selectedIcon;
                this.hideContextMenu();
                this.dispatchChange(this.value);
            };
            // endregion
        }
        get opened() { return __classPrivateFieldGet(this, _SdsIconPicker_opened_accessor_storage, "f"); }
        set opened(value) { __classPrivateFieldSet(this, _SdsIconPicker_opened_accessor_storage, value, "f"); }
        /**
         * Indicates whether the icon picker is in an invalid state.
         * This property can be used to style the component differently when invalid.
         *
         * @attr {boolean} invalid - Whether the icon picker is invalid.
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsIconPicker_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsIconPicker_invalid_accessor_storage, value, "f"); }
        /**
         * The error message to display when the icon picker is invalid.
         * This message will be shown to the user to provide context on the validation error.
         *
         * @attr {string} error-message - The message to display when an error occurs.
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsIconPicker_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsIconPicker_errorMessage_accessor_storage, value, "f"); }
        /**
         * The currently selected icon value.
         * This property holds the value of the selected icon. If no icon is selected,
         * it will be `undefined`.
         *
         * @attr {string | undefined} value - The value of the currently selected icon.
         */
        get value() { return __classPrivateFieldGet(this, _SdsIconPicker_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsIconPicker_value_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsIconPicker__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsIconPicker__contextMenu_accessor_storage, value, "f"); }
        get _iconPickerInput() { return __classPrivateFieldGet(this, _SdsIconPicker__iconPickerInput_accessor_storage, "f"); }
        set _iconPickerInput(value) { __classPrivateFieldSet(this, _SdsIconPicker__iconPickerInput_accessor_storage, value, "f"); }
        render() {
            return html `
            ${this.renderContainer()}
            <sds-context-menu id="context-menu">
                <sds-inner-icon-picker
                    .value="${this.value}"
                    @sds.inner-icon-picker.changed="${this.handleInnerIconPickerChange}"
                ></sds-inner-icon-picker>
            </sds-context-menu>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        // endregion
        // region lifecycle
        async firstUpdated() {
            this.initCmContentContainer();
            await this.updateComplete;
        }
        renderContainer() {
            if (isNil(this.value)) {
                return this.renderContainerUnselected();
            }
            else {
                return this.renderContainerSelected();
            }
        }
        renderContainerSelected() {
            return html `
            <sds-tooltip basic position="right">
                <div
                    class="${this.getInputClasses()}"
                    slot="trigger"
                    id="icon-picker-input"
                    @click="${this.toggleContextMenu}"
                >
                    <sds-icon size="24" name="${this.value}"></sds-icon>
                    <div class="sds-icon-picker-input__caret">${this.renderCaret()}</div>
                </div>
                <div slot="text">${this.renderTooltipContent()}</div>
            </sds-tooltip>
            ${this.renderError()}
        `;
        }
        renderContainerUnselected() {
            return html `
            <div
                class="${this.getInputClasses()}"
                id="icon-picker-input"
                @click="${this.toggleContextMenu}"
            >
                <span class="sds-icon-picker-input__empty">
                    <sds-clipped-text
                        basic
                        text="${translate('sds.icon_picker.none')}"
                    ></sds-clipped-text>
                </span>
                <div class="sds-icon-picker-input__caret">${this.renderCaret()}</div>
            </div>
            ${this.renderError()}
        `;
        }
        renderError() {
            if (this.errorMessage && this.invalid) {
                return html ` <sds-error message="${this.errorMessage}"></sds-error> `;
            }
        }
        renderTooltipContent() {
            if (isNil(this.value)) {
                return html `${translate('sds.icon_picker.no_selection')}`;
            }
            else {
                return html `${translate(resolveIconTranslationKey(this.value))}`;
            }
        }
        // endregion
        renderCaret() {
            if (this.opened) {
                return html ` <sds-icon size="24" name="arrow_up_small"></sds-icon> `;
            }
            else {
                return html ` <sds-icon size="24" name="arrow_down_small"></sds-icon> `;
            }
        }
        getInputClasses() {
            return classMap({
                'sds-icon-picker-input': true,
                'sds-icon-picker-input--focused': this.opened,
                'sds-icon-picker-input--invalid': this.invalid,
            });
        }
        // region context menu
        initCmContentContainer() {
            var _a;
            const innerIconPicker = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-inner-icon-picker');
            if (innerIconPicker) {
                this._innerIconPicker = innerIconPicker;
            }
        }
        dispatchChange(iconIdentifier) {
            this.dispatchEvent(new CustomEvent(SdsIconPicker.CHANGE_EVENT, {
                detail: {
                    selectedIcon: iconIdentifier,
                },
            }));
        }
    };
    _SdsIconPicker_opened_accessor_storage = new WeakMap();
    _SdsIconPicker_invalid_accessor_storage = new WeakMap();
    _SdsIconPicker_errorMessage_accessor_storage = new WeakMap();
    _SdsIconPicker_value_accessor_storage = new WeakMap();
    _SdsIconPicker__contextMenu_accessor_storage = new WeakMap();
    _SdsIconPicker__iconPickerInput_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsIconPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _opened_decorators = [property({ attribute: false })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _value_decorators = [property()];
        __contextMenu_decorators = [query('#context-menu')];
        __iconPickerInput_decorators = [query('#icon-picker-input')];
        __esDecorate(_classThis, null, _opened_decorators, { kind: "accessor", name: "opened", static: false, private: false, access: { has: obj => "opened" in obj, get: obj => obj.opened, set: (obj, value) => { obj.opened = value; } }, metadata: _metadata }, _opened_initializers, _opened_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __iconPickerInput_decorators, { kind: "accessor", name: "_iconPickerInput", static: false, private: false, access: { has: obj => "_iconPickerInput" in obj, get: obj => obj._iconPickerInput, set: (obj, value) => { obj._iconPickerInput = value; } }, metadata: _metadata }, __iconPickerInput_initializers, __iconPickerInput_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsIconPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.CHANGE_EVENT = 'sds.icon-picker.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsIconPicker = _classThis;
})();
export { SdsIconPicker };
